<template>
  <nav class="navbar fixed-top navbar-expand-lg p-0">
    <div class="container">
      <router-link :to="{ name: 'home' }" class="navbar-brand">
        <img :src="arkLogo" alt="" ref="navbarBrand" />
      </router-link>
      <button
        class="navbar-toggler shadow-none"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        ref="toggleIcon"
      >
        <div
          class="navbartoggler"
          ref="navbarToggler"
          @click="transitionToggleIcon()"
        >
          <span class="line"></span>
          <span class="line"></span>
          <span class="line"></span>
        </div>
      </button>
      <div
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
        ref="collapseBar"
      >
        <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link
              class="nav-link ps-0 pe-0"
              :to="{ name: 'products' }"
              ref="navLink"
              @click="collapseNavbar()"
              >Products</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link ps-0 pe-0"
              to=""
              ref="navLink"
              @click="collapseNavbar()"
              >Blog</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link ps-0 pe-0"
              :to="{ name: 'about' }"
              ref="navLink"
              @click="collapseNavbar()"
              >About</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link ps-0 pe-0"
              :to="{ name: 'contact' }"
              ref="navLink"
              @click="collapseNavbar()"
              >Contact</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link ps-0 pe-0"
              ref="navLink"
              :to="{ name: 'faq' }"
              @click="collapseNavbar()"
              >FAQ</router-link
            >
          </li>
        </ul>

        <div class="d-flex align-items-center join-ark-wrapper">
          <button
            class="btn btn-block btn-sm p-0 join-ark-btn"
            type="submit"
            ref="navLink"
            @click="collapseNavbar()"
          >
            Join the Ark
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { ref, onMounted } from "vue";
export default {
  name: "Navbar",
  setup() {
    // company brand image
    const arkLogo = "/img/Ark_Logo.png";
    const navbarBrand = ref(null);
    const navLink = ref(null);
    const collapseBar = ref(null);
    const toggleIcon = ref(null);
    const navbarToggler = ref(null);

    const screenWidth = screen.width;

    function mediaQuery() {
      if (screenWidth < 991) {
        navbarBrand.value.src = "/img/Ark_LogoSm.png";
      }
    }

    function collapseNavbar() {
      if (screenWidth < 991) {
        if (collapseBar.value.classList == "navbar-collapse collapse show") {
          collapseBar.value.classList = "navbar-collapse collapse";
        }
      }
    }

    function transitionToggleIcon() {
      navbarToggler.value.classList.toggle("is-active");
    }

    onMounted(mediaQuery);

    return {
      arkLogo,
      navbarBrand,
      collapseBar,
      toggleIcon,
      navbarToggler,
      navLink,
      collapseNavbar,
      transitionToggleIcon,
    };
  },
};
</script>

<style scoped>
* {
  text-decoration: none;
  list-style-type: none;
}
.navbar {
  background-color: var(--white);
  box-shadow: var(--bs);
  z-index: 999 !important;
}

.nav-link {
  font-family: var(--ff-openSans);
  font-weight: var(--fw-400);
  font-size: var(--fs-16);
  padding-left: 32px !important;
}
.sign-in-btn,
.separator {
  margin-right: 11px;
}
.join-ark-btn:focus,
.join-ark-btn:hover {
  background-color: var(--Cerulean);
  color: var(--white);
}

/* navbar on smaller device */
@media screen and (max-width: 991px) {
  .navbar {
    padding-bottom: 15px !important;
    top: 0 !important;
    z-index: 994 !important;
  }
  .navbar-toggler {
    border: none;
  }

  .navbar-toggler > * {
    transform: rotate(-180deg);
    transition: 0.2s ease-in-out;
  }
  .navbartoggler .line {
    width: 30px;
    height: 3px;
    background-color: rgb(96, 90, 90);
    display: block;
    margin: 8px auto;
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }
  .navbartoggler.is-active .line:nth-child(2) {
    opacity: 0;
  }

  .navbartoggler.is-active .line:nth-child(1) {
    -webkit-transform: translateY(11px) rotate(45deg);
    -ms-transform: translateY(11px) rotate(45deg);
    -o-transform: translateY(11px) rotate(45deg);
    transform: translateY(11px) rotate(45deg);
  }
  .navbartoggler.is-active .line:nth-child(3) {
    -webkit-transform: translateY(-11px) rotate(-45deg);
    -ms-transform: translateY(-11px) rotate(-45deg);
    -o-transform: translateY(-11px) rotate(-45deg);
    transform: translateY(-11px) rotate(-45deg);
  }

  .navbar-collapse {
    height: 100vh;

    margin-bottom: 200px !important;
  }
  .nav-link {
    padding-left: 0 !important;
    font-weight: var(--fw-700);
  }
  .nav-item {
    border-bottom: 1.5px solid rgba(69, 69, 69, 0.3);
    margin-top: 36px;
  }
  .join-ark-btn {
    margin-top: 50px;
    width: 100%;
    margin-bottom: 50px;
  }
}
</style>
